var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.2,10.8c-1.4-0.3-2.4-1.5-2.4-2.9c0-1.6,1.2-2.9,2.8-3c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-2,1.5-3.7,3.5-3.8c0,0,0,0,0.1,0\n\t\tc2.5,0,3.4,1.9,3.4,1.9l0,0c0.2,0,0.4-0.1,0.6-0.1c2.2,0,4,1.8,4,4c0,2-1.5,3.7-3.4,4","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t7.2,6.5 5.2,10.5 7.2,10.5 9.2,10.5 \t","key":1}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.2","y1":"10.5","x2":"7.2","y2":"14.9","key":2})]));
}

Upload.displayName = "Upload";

Upload.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Upload;

Upload.default = Upload;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/upload.svg
// module id = ../icon/src/icons/upload.svg
// module chunks = 0